import FiltersContainer from "./components/FiltersContainer";
import Post from "./components/Post";

import data from "./components/assets/data/data.json";
import { useEffect, useState } from "react";

const App = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    setFilteredData([...data]);
  }, []);

  useEffect(() => {
    if (filters.length > 0) {
      const newData = data.filter((job) => {
        const jobParams = [job.role, job.level, ...job.languages, ...job.tools];
        const jobParamsFiltered = jobParams.filter((param) =>
          filters.includes(param)
        );

        if (jobParamsFiltered.length === filters.length) return true;
        return false;
      });

      setFilteredData([...newData]);
    } else {
      setFilteredData([...data]);
    }
  }, [filters]);

  const addFilterHandler = (filter) => {
    const filterExists = filters.find((filterName) => filterName === filter);

    if (filterExists) return;

    setFilters((prevState) => [...prevState, filter]);
  };

  const removeFilterHandler = (filterName) => {
    const newFilters = filters.filter((filter) => filter !== filterName);
    setFilters([...newFilters]);
  };

  const clearFiltersHandler = () => {
    setFilters([]);
    setFilteredData(data);
  };

  return (
    <div className="min-h-screen bg-cyan-lighter-grayish py-5">
      {/* HEADER */}
      <div className="bg-cyan-desaturated-dark absolute left-0 top-0 min-w-full">
        <svg
          className="min-w-full xl:hidden"
          xmlns="http://www.w3.org/2000/svg"
          width="375"
          height="156"
        >
          <path
            fill="#63BABA"
            fill-rule="evenodd"
            d="M-86.732 487.429c-51.432-51.425-51.438-134.806-.013-186.237l.013-.013L309.926-95.424c51.441-51.434 134.836-51.434 186.277 0C547.634-44 547.64 39.38 496.216 90.813c-.005.004-.01.008-.013.013L99.543 487.429c-51.44 51.433-134.834 51.433-186.275 0zm-444.692 71.824c-51.432-51.424-51.438-134.806-.013-186.237l.013-.013L-134.766-23.6C-83.325-75.034.07-75.034 51.511-23.6c51.431 51.424 51.437 134.805.013 186.237l-.013.013-396.66 396.603c-51.44 51.433-134.834 51.433-186.275 0z"
          />
        </svg>
        <svg
          className="min-w-full hidden xl:block"
          xmlns="http://www.w3.org/2000/svg"
          width="1366"
          height="156"
          viewBox="0 0 1366 156"
        >
          <g fill="#63BABA" fill-rule="evenodd">
            <path d="M470.577 563.429c-51.432-51.425-51.438-134.806-.013-186.237l.013-.013L867.235-19.424c51.441-51.434 134.836-51.434 186.276 0 48.811 48.804 51.304 126.392 7.473 178.135l178.158-178.135c51.441-51.434 134.836-51.434 186.277 0 51.431 51.424 51.437 134.805.013 186.237-.005.004-.01.008-.013.013l-396.66 396.603c-51.44 51.433-134.834 51.433-186.275 0-48.812-48.805-51.304-126.394-7.471-178.138L656.853 563.43c-51.441 51.433-134.836 51.433-186.276 0zM342.268 45.605c-51.432-51.425-51.438-134.806-.013-186.237l.013-.013 396.658-396.603c51.441-51.434 134.836-51.434 186.277 0 51.431 51.424 51.437 134.805.013 186.237-.005.004-.01.008-.013.013L528.543 45.605c-51.44 51.433-134.834 51.433-186.275 0zm-444.692 71.824c-51.432-51.424-51.438-134.806-.013-186.237l.013-.013 396.658-396.603c51.441-51.434 134.836-51.434 186.277 0 51.431 51.424 51.437 134.805.013 186.237a80.86 80.86 0 01-.013.013L83.85 117.429c-51.44 51.433-134.834 51.433-186.275 0z" />
          </g>
        </svg>
      </div>

      {/* Filters Header */}
      <div className="flex flex-col items-center">
        <FiltersContainer
          filters={filters}
          removeFilterHandler={removeFilterHandler}
          onClearFiltersClick={clearFiltersHandler}
        />

        {/* Posts */}
        {filteredData.map((post) => (
          <Post
            key={post.company}
            companyName={post.company}
            jobTitle={post.position}
            isFeatured={post.featured}
            companyImage={post.logo}
            contract={post.contract}
            location={post.location}
            postedAt={post.postedAt}
            altLogo={post.company}
            languages={post.languages}
            tools={post.tools}
            level={post.level}
            role={post.role}
            onFilterClick={addFilterHandler}
            isNew={post.new}
          />
        ))}
      </div>
    </div>
  );
};

export default App;
